<ng-container class="p-2">
    <div class="row p-2">
        <div class="col-8">
            <div class="row row-cols-sm-auto mb-2">
                <div class="align-content-center fw-semibold me-3">
                    Total Jobs: {{ totalItems }}
                </div>
                <div class="align-content-center fw-semibold me-3">
                    Selected Items: {{ selectedTotalItems }}
                </div>
                @if(userType !== null && isSubUser()){
                <button
                    class="btn btn-primary reset-button"
                    (click)="completeJob()"
                    [disabled]="gridSelected.length === 0"
                >
                    Complete
                </button>
                }

                <button
                    class="btn btn-secondary reset-button"
                    (click)="toggleAllGroupings('expand')"
                >
                    Expand All <span><ng-icon
                            size="1em"
                            name="bootstrapArrowsAngleExpand"
                        ></ng-icon></span>
                </button>
                <button
                    class="btn btn-secondary reset-button"
                    (click)="toggleAllGroupings('collapse')"
                >
                    Collapse All <span><ng-icon
                            size="1em"
                            name="bootstrapArrowsAngleContract"
                        ></ng-icon></span>
                </button>

                <span class="align-content-center badge bg-secondary me-3 fs-6 fw-light">
                    Total Items: {{ data.length }}
                </span>
                <span class="align-content-center badge bg-secondary me-3 fs-6 fw-light">
                    Selected Items: {{ gridSelected.length }}
                </span>
            </div>
        </div>

        <div class="col-4 text-end mb-2">
            <button
                class="btn btn-secondary h-100"
                (click)="exportToCsv()"
            >Export</button>
        </div>
    </div>

    <div class="row">
        @if(gridProps && !isInitializing){
        <bryntum-grid
            #containerGrid
            [stateId]="this.containerGridStateId"
            [stateful]="gridProps.stateful!"
            [data]="data"
            [height]="gridHeight"
            [columns]="gridProps.columns!"
            [filterBarFeature]="gridProps.filterBarFeature!"
            [cellEditFeature]="gridProps.cellEditFeature!"
            [excelExporterFeature]="gridProps.excelExporterFeature!"
            [listeners]="gridProps.listeners!"
            [store]="gridProps.store!"
            [selectionMode]="gridProps.selectionMode!"
            [cellMenuFeature]="gridProps.cellMenuFeature!"
            [cellTooltipFeature]="gridProps.cellTooltipFeature!"
            (onSelectionChange)="onGridSelectionChange($event)"
        ></bryntum-grid>
        }
    </div>
</ng-container>
